module.exports = __webpack_public_path__ + "static/scoring-cc1e701d87fa707b09e20d22ea2fce5d.png";